import { useDispatch, useSelector } from "react-redux";
import {
  convertImageNameToWeb,
  formatMoney,
} from "../../../helpers/helperFunctions";
import CartItemCounter from "../../atoms/CartItemCounter/CartItemCounter";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../atoms/Button";
import { getTrackMakesAndModels } from "../../../store/slices/ProductFinder/ProductFinderSlice";

export default function CartDetail() {
  const { cartItems, cart } = useSelector((state) => state.cart);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCheckout = () => {
    navigate("/checkout");
  };

  const { submitOrders } = useSelector((state) => state.admin);

  const fetchTrackMatches = (productCode) => {
    dispatch(getTrackMakesAndModels({ product_code: productCode }));
  };

  return (
    <>
      <main className="relative lg:min-h-full">
        <div>
          <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-4 lg:py-16 xl:gap-x-24">
            <div className="lg:col-start-0">
              <h1 className="text-md font-medium text-[var(--primary-color)]">
                Cart Items
              </h1>
              <ul className="mt-6 divide-y divide-gray-200 border-gray-200 text-sm font-medium text-gray-500">
                {cartItems.map((item) => {
                  return (
                    <li
                      key={item.product_code}
                      className="flex flex-col space-y-4 py-6"
                    >
                      <div className="flex space-x-6">
                        {item?.product?.image_name && (
                          <img
                            alt={item?.product?.image_name}
                            src={
                              process.env.REACT_APP_IMAGE_URL +
                              convertImageNameToWeb(item?.product?.image_name)
                            }
                            className="h-32 w-32 flex-none rounded-md bg-gray-100 object-contain p-2"
                          />
                        )}

                        <div className="flex-auto space-y-1">
                          <h3 className="text-gray-900">
                            <p>{item.product.description}</p>
                          </h3>
                          <div className="flex gap-2 items-center">
                            <p>
                              {item.last_price
                                ? `${formatMoney(item.last_price)}`
                                : "-"}{" "}
                              x{" "}
                            </p>
                            <CartItemCounter cartItem={item} />
                          </div>
                          <div className="flex gap-2 items-center">
                            <p>
                              {item.tariff_amount
                                ? `${formatMoney(item.tariff_amount)}`
                                : "-"}{" "}
                              x{" "}{item.quantity} Tariff
                            </p>
                          </div>
                          <div className="flex gap-2 items-center">
                            <p>
                              {item.product.shipping_weight
                                ? `${item.product.shipping_weight} lbs`
                                : "-"}{" "}
                              x {item.quantity}
                            </p>
                          </div>
                          <p>{item.product.xref_code}</p>
                          <p>{item.product_code}</p>
                          {["16", "17"].includes(
                            item.product_code.substring(0, 2)
                          ) && (
                            <p
                              onClick={() =>
                                fetchTrackMatches(item.product_code)
                              }
                              className="text-[var(--primary-color)] hover:cursor-pointer hover:text-[var(--secondary-color)]"
                            >
                              What does this fit?
                            </p>
                          )}
                        </div>
                        <div>
                          <p className="flex-none font-medium text-gray-900 text-right">
                            {item.last_price
                              ? `${formatMoney(item.last_price * item.quantity + (item.tariff_amount || 0) * item.quantity)}`
                              : "-"}
                          </p>
                          <p className="flex-none font-medium text-gray-900 text-right">
                            {item.product.shipping_weight
                              ? `${(item.product.shipping_weight * item.quantity).toFixed(2)} lbs`
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
              {cartItems.length === 0 && (
                <h2 className="text-center text-2xl font-semibold">
                  Your cart is empty. Return <a href="/">home</a> to add your
                  first item!
                </h2>
              )}
            </div>
            <div className="lg:col-start-2">
              <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                Ready to Checkout?
              </p>

              <dl className="space-y-3 mt-4 border-t border-gray-200 pt-2 text-md font-medium text-gray-500">
                <div className="flex justify-between">
                  <dt>Subtotal</dt>
                  <dd className="text-gray-900">
                    {!cart.cart_total ? "-" : formatMoney(cart.cart_total)}
                  </dd>
                </div>
                <div className="flex justify-between">
                  <dt>Weight</dt>
                  <dd className="text-gray-900">
                    {!cart.total_weight ? "-" : cart.total_weight} lbs
                  </dd>
                </div>
              </dl>
              <div className="flex border-t mt-3 py-6 justify-between">
                <div>
                  <Button
                    type="theme"
                    textContent="Checkout Now"
                    onClick={handleCheckout}
                    disabled={cartItems.length === 0}
                  />
                </div>
                <div className="border-gray-200 text-right">
                  <Link
                    to="/"
                    className="text-sm font-medium text-[var(--primary-color)] hover:text-[var(--secondary-color)]"
                  >
                    Back to Home
                    <span aria-hidden="true"> &rarr;</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
